import { Record } from 'immutable'
import { Layout } from './constants'

export const Overview = Record({
  handle: '',
  globalHandle: '',
  quote: '',
  jobTitle: '',
  latitude: '',
  longitude: '',
  location: '',
})

export const Social = Record({
  calendarUrl: '',
  calendarCta: '',
  enableCalendarCta: true,
  phoneNumber: '',
  twitterHandle: '',
  linkedInHandle: '',
  instagramHandle: '',
  mediumHandle: '',
  pinterestHandle: '',
  skypeHandle: '',
  soundCloudHandle: '',
  facebookHandle: '',
})

export const Details = Record({
  bio: '',
  educationInfo: '',
  likes: '',
  funFact: '',
  blogUrl: '',
  languages: '',
  podcastUrl: '',
})

export const Messaging = Record({
  welcomeMessage: '',
  awayMessage: '',
})

export const Theme = Record({
  layout: Layout.CARD,
  coverPhotoUrl: '',
})

export const Profile = Record({
  handle: '',
  globalHandle: '',
  quote: '',
  jobTitle: '',
  calendarUrl: '',
  calendarCta: '',
  coverPhotoUrl: '',
  enableCalendarCta: true,
  phoneNumber: '',
  twitterHandle: '',
  linkedInHandle: '',
  instagramHandle: '',
  mediumHandle: '',
  pinterestHandle: '',
  skypeHandle: '',
  soundCloudHandle: '',
  facebookHandle: '',
  bio: '',
  educationInfo: '',
  funFact: '',
  blogUrl: '',
  podcastUrl: '',
  languages: '',
  companyName: '',
  companyUrl: '',
  latitude: '',
  likes: '',
  location: '',
  longitude: '',
  welcomeMessage: '',
  awayMessage: '',
  layout: Layout.CARD,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/profile/models.js